const menuModals: { [key: string]: string } = {
  "gantt_chart": "gantt",
  "map": "map",
  "settings": "settings",
  "sparce_point_cloud": "settings",
  "dense_point_cloud": "settings",
  "reports": "report"
};

export default menuModals;